export default function useValidation() {
    const mxRules = {
        required: value => !!value || value === 0 || 'Ce Champ est Requis',
        listRequired: v => (Array.isArray(v) && v.length > 0) || "Ce Champ est Requis",
        radioRequired: value => value !== null && value !== undefined || 'Ce Champ est Requis',
        isNotEmptyObject: value => Object.keys(value).length !== 0 || 'Ce Champ est Requis',
        booleanRequired: value => value !== null || 'Ce Champ est Requis',
        integer: value => Number.isInteger(Number(value)) || "Ce champ doit etre un entier",
        decimal: value => value % 1 !== 0 || "Ce champ doit etre un decimale",
        email: v => /.+@.+\..+/.test(v) || 'E-mail n\'est pas valide',
        passwordMatch(v2) {
            return v => (v === v2) || 'Le mot de passe n\'est pas identique'
        },
        lessThan(p) {
            return v => v.length <= p || 'Le nom doit comporter moins de ' + p + ' caractères';
        },
        minValue(p) {
            return v => v !== null && v !== undefined && v !== '' && Number(v) >= p || 'La valeur doit être supérieure ou égale à ' + p;
        },
        maxValue(p) {
            return v => v !== null && v !== undefined && v !== '' && Number(v) <= p || 'La valeur doit être inférieure ou égale à ' + p;
        }
    }

    return {mxRules}
}